import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://marinconstruesfuerzo.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'LocalBusiness',
      '@id': `${siteUrl}/#business`,
      name: 'Marin Construesfuerzo SL',
      legalName: 'Marin Construesfuerzo SL',
      taxID: 'B26637975',
      url: siteUrl,
      telephone: '+34613725305',
      email: 'm.construesfuerzo@gmail.com',
      image: 'https://static.readdy.ai/image/b449e92a87efa96149f112abe38ee1bc/4647924add033c8d11693d73219fb188.jpeg',
      description: 'Empresa de construcción general en Arrecife, Lanzarote. Reformas integrales, pintura, electricidad, fontanería, pladur e impermeabilizaciones.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'CL Victor Hugo, 91',
        addressLocality: 'Arrecife',
        addressRegion: 'Las Palmas',
        postalCode: '35500',
        addressCountry: 'ES',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 28.9636,
        longitude: -13.5477,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '09:00',
          closes: '14:00',
        },
      ],
      sameAs: ['https://www.instagram.com/m.construesfuerzo'],
      areaServed: {
        '@type': 'Place',
        name: 'Lanzarote, Islas Canarias, España',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Construcción en Lanzarote',
        itemListElement: [
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Construcción General' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Reformas Integrales' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pintura Profesional' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fontanería' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Electricidad' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Impermeabilizaciones' } },
          { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Pladur' } },
        ],
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Marin Construesfuerzo SL',
      inLanguage: 'es-ES',
      publisher: { '@id': `${siteUrl}/#business` },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Arrecife Lanzarote Construcción General Pintura Fontanería | Marin Construesfuerzo SL',
      description: 'Empresa de construcción general en Arrecife, Lanzarote. Reformas integrales, pintura, electricidad, fontanería, pladur e impermeabilizaciones.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#business` },
      inLanguage: 'es-ES',
    },
  ],
};

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Arrecife Lanzarote Construcción General Pintura Fontanería | Marin Construesfuerzo SL"
        description="Marin Construesfuerzo SL — Empresa de construcción general en Arrecife, Lanzarote. Reformas integrales, pintura, electricidad, fontanería, pladur e impermeabilizaciones. Más de una década de experiencia. Contacto: 613 72 53 05."
        canonical={siteUrl}
        jsonLd={homeJsonLd}
      />
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Services />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}
